import React from 'react';
import { useAuthentication } from '../../auth';
import { useChatbot } from './use-chatbot';
import { useExcludeChatbotFromPath } from './useExcludeChatbotFromPath';

interface KeycloakChatbotProps {
    excludedPaths?: string[];
    context: Record<string, unknown>;
    userId?: string;
    mercuryApiKey: string;
    mercuryCssUrl: string;
    jestWorkerId?: string;
}

export const ChatbotKeycloak: React.FC<KeycloakChatbotProps> = ({
    excludedPaths,
    context,
    userId,
    mercuryApiKey,
    mercuryCssUrl,
    jestWorkerId,
}) => {
    const auth = useAuthentication();

    useExcludeChatbotFromPath(excludedPaths);
    const { idpSub: customerID } = auth.tokenParsed as { idpSub: string };
    useChatbot(customerID, context, userId, mercuryApiKey, jestWorkerId);

    return (
        <div data-testid="mercury-widget-snippet">
            <link rel="stylesheet" type="text/css" href={mercuryCssUrl} />
        </div>
    );
};
